import { render, staticRenderFns } from "./DocumentCustomFieldDialog.vue?vue&type=template&id=d611381c&scoped=true"
import script from "./DocumentCustomFieldDialog.vue?vue&type=script&lang=js"
export * from "./DocumentCustomFieldDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentCustomFieldDialog.vue?vue&type=style&index=0&id=d611381c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d611381c",
  null
  
)

export default component.exports